export const config = {
  version: '2.1.0',
  os: 'win', // lin/mac/win
  // HOST_WS: 'ws://127.0.0.1:8443/websocket',
  // HOST_HTTP: 'http://127.0.0.1:8443',
  HOST_WS: 'wss://traffic.sdkd.com.vn/websocket',
  HOST_HTTP: 'https://traffic.sdkd.com.vn',
  MAP_KEY: 'AIzaSyC1WFY7kqYrer5FxiXyCramtJ1vKCy9Dwg'
}